module.exports = __webpack_public_path__ + "img/Group 6825@2x.3ad20e4a.jpg";